import axios from 'axios';
import _ from 'lodash';
import * as features from '../../const/Features';

export default {
  isFeatureEnabled
};

window.featureStatus = _.transform(
  features,
  (cache, feature) => {
    cache[feature.name] = null;
  },
  {}
);

const FEATURE_TOGGLE_URL = '/feature/check';

function isFeatureEnabled(feature) {
  if (!window.featureStatus[feature.name]) {
    window.featureStatus[feature.name] = new Promise(resolve => {
      axios
        .get(`${FEATURE_TOGGLE_URL}?feature=${feature.name}`)
        .then(response => {
          resolve(response.data);
        })
        .catch(() => {
          resolve(false);
        });
    });
  }

  return window.featureStatus[feature.name];
}



// WEBPACK FOOTER //
// ./src/services/feature/FeatureService.js